<div class="row">
  <div class="col-md-12">
    <nb-card>
      <nb-card-header>{{ 'tytul.platnosci' | translate }}</nb-card-header>
      <nb-card-body>
        <!-- Payment status indicator -->
        <div class="payment-status-indicator mb-3" *ngIf="platnosci?.length > 0">
          <div class="d-flex align-items-center" *ngIf="allInvoicesPaid">
            <nb-icon icon="checkmark-circle-outline" class="success-icon mr-2"></nb-icon>
            <span class="text-success">{{ 'komunikat.brak-niezaplaconych-faktur' | translate }}</span>
          </div>
          <div class="d-flex align-items-center" *ngIf="!allInvoicesPaid">
            <nb-icon icon="close-circle-outline" class="danger-icon mr-2"></nb-icon>
            <span class="text-danger">{{ 'komunikat.niezaplacone-faktury' | translate }}</span>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <div>
            <section>
              <div>{{ 'akcja.wybierz-okres' | translate }}:</div>
            </section>
            <section class="mt-2 ml-3">
              <ngx-zakres-dat 
                [skipLocalStorage]="hideSummary"
                (zmianaZakresu)="onChangeZmianaZakresu($event)"></ngx-zakres-dat>
            </section>
          </div>
          <div>
            <div><strong>{{ 'info.kontakt.konto-bankowe' | translate }}</strong></div>
            <div>BNP Paribas Bank Polska S.A.</div>
            <div>68175000120000000013837578 <button nbButton size="small" status="basic" (click)="kopiujNumer()">{{ 'akcja.kopiuj' | translate }}</button></div>
          </div>
        </div>
        <ngx-platnosci-tabela [dane]="platnosci" [zakresDat]="zakresDat" [hideSummary]="hideSummary"></ngx-platnosci-tabela>
      </nb-card-body>
    </nb-card>
  </div>
</div>